/**
 * PerformanceResourceHints - DNS prefetch + preconnect + font preload
 * Injected via direct DOM manipulation for reliability.
 */
import { useEffect } from 'react';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';

const PRECONNECT_DOMAINS = [
  'https://fonts.googleapis.com',
  'https://fonts.gstatic.com',
  ...(SUPABASE_URL ? [SUPABASE_URL] : []),
];

const DNS_PREFETCH_DOMAINS = [
  'https://www.google-analytics.com',
  'https://www.googletagmanager.com',
  'https://fonts.googleapis.com',
  'https://fonts.gstatic.com',
  'https://www.google.com',
  'https://maps.googleapis.com',
  'https://cdn.jsdelivr.net',
  'https://api.indexnow.org',
  ...(SUPABASE_URL ? [SUPABASE_URL] : []),
];

export function PerformanceResourceHints() {
  useEffect(() => {
    const head = document.head;
    const tag = 'data-perf-hint';

    // Remove stale hints
    head.querySelectorAll(`[${tag}]`).forEach(el => el.remove());

    // Preconnect
    PRECONNECT_DOMAINS.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      link.crossOrigin = 'anonymous';
      link.setAttribute(tag, 'true');
      head.appendChild(link);
    });

    // DNS prefetch
    DNS_PREFETCH_DOMAINS.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'dns-prefetch';
      link.href = href;
      link.setAttribute(tag, 'true');
      head.appendChild(link);
    });

    // Preload hero font file (woff2 for Inter 700)
    const fontPreload = document.createElement('link');
    fontPreload.rel = 'preload';
    fontPreload.as = 'style';
    fontPreload.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap';
    fontPreload.setAttribute(tag, 'true');
    head.appendChild(fontPreload);

    // Also preconnect fonts.gstatic.com for actual font file delivery
    const gstaticPreconnect = document.createElement('link');
    gstaticPreconnect.rel = 'preconnect';
    gstaticPreconnect.href = 'https://fonts.gstatic.com';
    gstaticPreconnect.crossOrigin = 'anonymous';
    gstaticPreconnect.setAttribute(tag, 'true');
    head.appendChild(gstaticPreconnect);
  }, []);

  return null;
}
